export const sumBy = (arr, fn) =>
  arr
    .map(typeof fn === 'function' ? fn : (val) => val[fn])
    .reduce((acc, val) => acc + val, 0);

export const calculateAmountDiscounted = (totalAfterDiscount, discount) => {
  return totalAfterDiscount / ((100 - discount) / 100) - totalAfterDiscount;
};
export const calculateOriginalPrice = (subtotal, discount) => {
  return subtotal / (1 - discount / 100);
};

export const calculateInvoiceDiscountAmount = (invoice, teamDiscountAmount) => {
  if (invoice && teamDiscountAmount) {
    const calculatedTeamDiscountAmount = calculateAmountDiscounted(
      invoice.TotalAmount - invoice.TaxAmount,
      teamDiscountAmount
    );
    return invoice?.Lines
      ? sumBy(invoice.Lines, (l) => l.DiscountAmount) +
          calculatedTeamDiscountAmount
      : calculatedTeamDiscountAmount;
  }
};
